<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-renzleix`]" width="1em" height="1em" v-bind="$attrs"><g :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="nonzero"><path d="M47.2919885,0.727292394 C48.9685502,-0.242430798 51.0341593,-0.242430798 52.710721,0.727292394 L97.2906338,26.5130691 C98.9671528,27.4827677 100,29.2748261 100,31.2142233 L100,82.7857767 C100,84.7251739 98.9671528,86.5172323 97.2906338,87.4869309 L52.710721,113.272708 C51.0341593,114.242431 48.9685502,114.242431 47.2919885,113.272708 L2.70936636,87.4869309 C1.03284725,86.5172323 0,84.7251739 0,82.7857767 L0,31.2142233 C0,29.2748261 1.03284725,27.4827677 2.70936636,26.5130691 L47.2919885,0.727292394 Z M10.8374652,34.3492309 L10.8374652,79.6507691 L50.0013547,102.304252 L89.1625349,79.6507691 L89.1625349,34.3492309 L50.0013547,11.6957475 L10.8374652,34.3492309 Z" transform="translate(19 8)"/><path d="M73.6994918,37 L79,46.4513448 L55,59.974 L55,84 L44,84 L44,59.42 L21,46.4486344 L26.3059169,37 L49.9932392,50.3625265 L73.6994918,37 Z" transform="translate(19 8)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmRenzleix',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
